/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/RecipientDetailsDigital.js
 * Created:       Tue Apr 15 2025
 * Modified By:   Greg Olive
 * Last Modified: Tue Apr 22 2025
 */

import React, {useState, useContext} from 'react';
import {Tabs, ImageRadio, Legend, FormSection, RadioButtons, LoadingSpinner, TextField, TextArea, CheckBox, Button, MicroModal, PhoneCodeSelect} from "@proxy/_components";
import {TranslationsContext, FormContext} from '@proxy/_contexts';

export default function RecipientDetailsDigital() {

  const translations = useContext(TranslationsContext);
  const {
    settings,
    formData,
    formErrors,
    updateFormField,
    bulkOrder,
  }  = useContext(FormContext);

  const emailMarkup = (
    <TextField
      value={formData.properties._gcp_recipient_email || ""}
      label={translations.recipient_email_label}
      placeholder={translations.recipient_email_placeholder}
      type={"email"}
      name="properties[_gcp_recipient_email]"
      validation="email"
      onChange={(e) => {
        updateFormField("properties._gcp_recipient_email", e.target.value);
      }}
      error={formErrors._gcp_recipient_email}
      className="gc__recipient-email"
    />
  );

  const mobilePhoneMarkup = (settings.digital.giftcard.enable_sms === "1" || settings.digital.giftcard.enable_sms === true) && formData.properties._gcp_send_to_self !== true && (
    <>
    <PhoneCodeSelect
    //defaultCountryCode={settings.shop.country_code}
    value={formData.properties._gcp_recipient_phone || ""}
    label={translations.recipient_mobile_number_label}
    placeholder={translations.recipient_mobile_number_placeholder}
    type={"tel"}
    name="properties[_gcp_recipient_phone]"
    validation="phone"
    onChange={(newValue, fromSDK = false) => updateFormField("properties._gcp_recipient_phone", newValue, fromSDK)}
    error={formErrors._gcp_recipient_phone}
    />
    {formData.properties._gcp_recipient_phone && formData.properties._gcp_recipient_phone.startsWith("+1") && (
      <p className={"gc__message_details_hint"}>
        {translations.recipient_mobile_number_help}
      </p>
    )}
    </>
  );

  const nameMarkup = formData.properties._gcp_send_to_self !== true && (
    <TextField
      value={formData.properties._gcp_recipient_name || ""}
      label={translations.recipient_name_label}
      placeholder={translations.recipient_name_placeholder}
      type={"text"}
      name="properties[_gcp_recipient_name]"
      onChange={(e) => {
        updateFormField("properties._gcp_recipient_name", e.target.value);
      }}
      error={formErrors._gcp_recipient_name}
      className="gc__recipient-name"
    />
  );

  return (
    <FormSection
      title={ translations.recipient_details_heading }
    >
    {bulkOrder === false && (
      <div className={"gc__message_checkboxes_div"}>
        <CheckBox
          checked={formData.properties._gcp_send_to_self}
          label={translations.send_to_myself_label}
          name="properties[_gcp_send_to_self]"
          onChange={() => {
            updateFormField("properties._gcp_send_to_self", !formData.properties._gcp_send_to_self);
          }}
        />
      </div>
    )}
    <div className={"gc__message_details_div"}>
      {emailMarkup}
      {mobilePhoneMarkup}
      {nameMarkup}
    </div>
    </FormSection>
  );
};
